export * from './virtualmachine-overview-template';
